export default class BaseForm extends Backbone.View {
    constructor(o) {
      super(o);
    }
}
